import React, { useEffect, useRef, useState } from 'react';

import Modal from '~/components/modals/modal';
import LoadingIndicator from '~/components/loading-indicator';
import DigitalSoilTest from '~/components/lawns/digital-soil-test/digital-soil-test';
import { useLawnMutations } from '~/features/lawns/lawn-actions';
import { useDigitalSoilTest } from '~/hooks/use-digital-soil-test';

import styles from '~/components/modals/modal.module.scss';

const SoilTestModal = ({ isOpen, onClose, address }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen} className={styles.soilTestModal}>
      <Content isOpen={isOpen} onClose={onClose} address={address} />
    </Modal>
  );
};

const Content = ({ isOpen, onClose, address }) => {
  const [lawnUuid, setLawnUuid] = useState(null);
  const creatingLawn = useRef(false);
  const { digitalSoilTest } = useDigitalSoilTest(lawnUuid);
  const { createLawn } = useLawnMutations();

  useEffect(() => {
    if (isOpen && !lawnUuid && !creatingLawn.current) {
      createLawn.current = true;
      createLawn(address)
        .then((lawn) => {
          setLawnUuid(lawn.uuid);
        })
        .finally(() => (creatingLawn.current = false));
    }
  }, [address, createLawn, isOpen, lawnUuid]);
  return (
    <>
      {!digitalSoilTest ? (
        <div className={styles.loadingContainer}>
          <h1>Getting your soil analysis...</h1>
          <br />
          <LoadingIndicator />
        </div>
      ) : (
        <DigitalSoilTest digitalSoilTest={digitalSoilTest} onClose={onClose} />
      )}
    </>
  );
};

export default SoilTestModal;
